import Section from "@/components/ui/section";
import React from "react";

export default function About() {
  return (
    <Section>
      <div className="mx-auto lg:max-w-[1080px] w-full flex flex-col gap-6">
        <p className="text-body text-center md:text-base text-sm">
          Soule Scale is a consulting company established in 2021 to provide its
          clients with financial, grant management, and other allied services
          (specifically defined in the tab “Our Services”) and to support some
          grassroots organizations in terms of their capacity building for
          program implementation and financial management.
        </p>
        <p className="text-body text-center md:text-base text-sm">
          We specialize in strengthening financial systems and internal controls
          and ensuring compliance with statutory regulations for the development
          sector. Our expert team, with over 35 years of combined experience,
          excels in accounting, financial management, and legal compliances such
          as income tax, FCRA, and GST. We also hold experience in handling
          financial compliances and managing grants for our clients in US and
          UK.
        </p>
        <p className="text-body text-center md:text-base text-sm">
          Our practical and customized solutions support organizations of all
          sizes, resolving complex compliance issues and promoting best
          financial practices. You can trust us to handle your
          organization&apos;s compliance and financial management, allowing you
          to focus on your field programs.
        </p>
        <p className="text-body text-center md:text-base text-sm">
          Collaborate with Soulscale Consulting today to unlock the expertise
          and resources to drive your organization&apos;s growth and success.
          Let us assist you in making a positive impact and bring about
          sustainable change. Connect with us now.
        </p>
      </div>
    </Section>
  );
}
